// Helper function to create mock event data with dynamic dates
const generateMockEventData = () => {
  // Helper to create dates relative to today
  const relativeDate = (hours, minutes = 0) => {
    const date = new Date()
    date.setHours(hours, minutes, 0, 0)
    return date.toISOString()
  }

  // Helper to create dates for tomorrow
  const tomorrowDate = (hours, minutes = 0) => {
    const date = new Date()
    date.setDate(date.getDate() + 1)
    date.setHours(hours, minutes, 0, 0)
    return date.toISOString()
  }

  // Helper to create dates for yesterday
  const yesterdayDate = (hours, minutes = 0) => {
    const date = new Date()
    date.setDate(date.getDate() - 1)
    date.setHours(hours, minutes, 0, 0)
    return date.toISOString()
  }

  return [
    // Operating Room 1 - TODAY
    {
      eventId: 'EVENT-1001',
      theatreRoom: 'Operating Room 1',
      eventType: 'Procedure',
      eventStart: relativeDate(8, 30),
      eventEnd: relativeDate(10, 0),
      responsibleStaff: 'Dr. Sarah Johnson',
      eventDetails: 'Appendectomy',
      patientId: 'PT-1542',
      patientName: 'Kevin Thompson',
      status: 'Completed',
      notes: 'Procedure completed successfully, no complications',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Michael Harris', 'Dr. Daniel Wright', 'Nurse Emily Clark', 'Nurse Jason Rodriguez']
    },
    {
      eventId: 'EVENT-1002',
      theatreRoom: 'Operating Room 1',
      eventType: 'Cleaning',
      eventStart: relativeDate(10, 0),
      eventEnd: relativeDate(10, 30),
      responsibleStaff: 'Cleaning Team A',
      eventDetails: 'Terminal cleaning between cases',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'Standard cleaning protocol followed',
      eventCategory: 'Maintenance',
      associatedStaff: ['John Doe', 'Jane Smith']
    },
    {
      eventId: 'EVENT-1003',
      theatreRoom: 'Operating Room 1',
      eventType: 'Procedure',
      eventStart: relativeDate(10, 30),
      eventEnd: relativeDate(12, 15),
      responsibleStaff: 'Dr. Sarah Johnson',
      eventDetails: 'Hernia Repair',
      patientId: 'PT-1563',
      patientName: 'Laura Martinez',
      status: 'In Progress',
      notes: 'Case started on time',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Michael Harris', 'Dr. Daniel Wright', 'Nurse Emily Clark', 'Nurse Jason Rodriguez']
    },
    {
      eventId: 'EVENT-1004',
      theatreRoom: 'Operating Room 1',
      eventType: 'Patient Prep',
      eventStart: relativeDate(13, 0),
      eventEnd: relativeDate(13, 30),
      responsibleStaff: 'Nurse Jason Rodriguez',
      eventDetails: 'Pre-operative preparation',
      patientId: 'PT-1575',
      patientName: 'David Wilson',
      status: 'Scheduled',
      notes: 'Patient scheduled for laparoscopic procedure',
      eventCategory: 'Pre-Op',
      associatedStaff: ['Nurse Emily Clark']
    },
    {
      eventId: 'EVENT-1005',
      theatreRoom: 'Operating Room 1',
      eventType: 'Procedure',
      eventStart: relativeDate(13, 30),
      eventEnd: null,
      responsibleStaff: 'Dr. Sarah Johnson',
      eventDetails: 'Laparoscopic Appendectomy',
      patientId: 'PT-1575',
      patientName: 'David Wilson',
      status: 'Scheduled',
      notes: 'Complex case, patient has previous abdominal surgeries',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Michael Harris', 'Dr. Daniel Wright', 'Nurse Emily Clark', 'Nurse Jason Rodriguez']
    },

    // Operating Room 2 - TODAY
    {
      eventId: 'EVENT-2001',
      theatreRoom: 'Operating Room 2',
      eventType: 'Procedure',
      eventStart: relativeDate(7, 45),
      eventEnd: relativeDate(11, 15),
      responsibleStaff: 'Dr. James Wilson',
      eventDetails: 'Total Hip Replacement',
      patientId: 'PT-1498',
      patientName: 'Robert Garcia',
      status: 'Completed',
      notes: 'Procedure took longer than expected due to anatomical complexity',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Rachel Brown', 'Dr. Emma Taylor', 'Nurse Thomas White', 'Nurse Catherine Lee']
    },
    {
      eventId: 'EVENT-2002',
      theatreRoom: 'Operating Room 2',
      eventType: 'Cleaning',
      eventStart: relativeDate(11, 15),
      eventEnd: relativeDate(12, 0),
      responsibleStaff: 'Cleaning Team B',
      eventDetails: 'Terminal cleaning between cases',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'Deep cleaning performed',
      eventCategory: 'Maintenance',
      associatedStaff: ['Robert Johnson', 'Maria Garcia']
    },
    {
      eventId: 'EVENT-2003',
      theatreRoom: 'Operating Room 2',
      eventType: 'Procedure',
      eventStart: relativeDate(12, 0),
      eventEnd: relativeDate(13, 30),
      responsibleStaff: 'Dr. James Wilson',
      eventDetails: 'Knee Arthroscopy',
      patientId: 'PT-1587',
      patientName: 'William Davis',
      status: 'In Progress',
      notes: 'Case started on time',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Rachel Brown', 'Dr. Emma Taylor', 'Nurse Thomas White', 'Nurse Catherine Lee']
    },
    {
      eventId: 'EVENT-2004',
      theatreRoom: 'Operating Room 2',
      eventType: 'Equipment Check',
      eventStart: relativeDate(14, 0),
      eventEnd: relativeDate(15, 0),
      responsibleStaff: 'Biomedical Engineering',
      eventDetails: 'Arthroscopy Tower Maintenance',
      patientId: null,
      patientName: null,
      status: 'Scheduled',
      notes: 'Routine maintenance of arthroscopy equipment',
      eventCategory: 'Maintenance',
      associatedStaff: ['James Peterson', 'Emily Cooper']
    },

    // Operating Room 3 - TODAY
    {
      eventId: 'EVENT-3001',
      theatreRoom: 'Operating Room 3',
      eventType: 'Cleaning',
      eventStart: relativeDate(8, 0),
      eventEnd: relativeDate(9, 30),
      responsibleStaff: 'Cleaning Team C',
      eventDetails: 'Deep cleaning following infectious case',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'Enhanced cleaning protocol implemented',
      eventCategory: 'Maintenance',
      associatedStaff: ['Sarah Williams', 'Thomas Brown']
    },
    {
      eventId: 'EVENT-3002',
      theatreRoom: 'Operating Room 3',
      eventType: 'Procedure',
      eventStart: relativeDate(9, 30),
      eventEnd: relativeDate(11, 45),
      responsibleStaff: 'Dr. Robert Chen',
      eventDetails: 'Laparoscopic Cholecystectomy',
      patientId: 'PT-1502',
      patientName: 'Jennifer Wilson',
      status: 'Completed',
      notes: 'Procedure completed with no complications',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Michael Harris', 'Dr. Amanda Parker', 'Nurse Amanda Rodriguez', 'Nurse David Wong']
    },
    {
      eventId: 'EVENT-3003',
      theatreRoom: 'Operating Room 3',
      eventType: 'Patient Prep',
      eventStart: relativeDate(12, 30),
      eventEnd: relativeDate(13, 0),
      responsibleStaff: 'Nurse Amanda Rodriguez',
      eventDetails: 'Pre-operative preparation',
      patientId: 'PT-1603',
      patientName: 'Elizabeth Chen',
      status: 'Completed',
      notes: 'Patient prepared for thyroidectomy',
      eventCategory: 'Pre-Op',
      associatedStaff: ['Nurse David Wong']
    },
    {
      eventId: 'EVENT-3004',
      theatreRoom: 'Operating Room 3',
      eventType: 'Procedure',
      eventStart: relativeDate(13, 0),
      eventEnd: null,
      responsibleStaff: 'Dr. Robert Chen',
      eventDetails: 'Thyroidectomy',
      patientId: 'PT-1603',
      patientName: 'Elizabeth Chen',
      status: 'In Progress',
      notes: 'Procedure ongoing, no complications reported',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Amanda Parker', 'Nurse Amanda Rodriguez', 'Nurse David Wong']
    },

    // Operating Room 4 - TODAY
    {
      eventId: 'EVENT-4001',
      theatreRoom: 'Operating Room 4',
      eventType: 'Procedure',
      eventStart: relativeDate(7, 0),
      eventEnd: relativeDate(14, 0),
      responsibleStaff: 'Dr. Maria Garcia',
      eventDetails: 'Coronary Artery Bypass',
      patientId: 'PT-1367',
      patientName: 'Patricia White',
      status: 'Completed',
      notes: 'Complex case, patient stable in recovery',
      eventCategory: 'Surgery',
      associatedStaff: [
        'Dr. Robert Chen',
        'Dr. John Peterson',
        'Nurse Sarah Collins',
        'Nurse Michael Chen',
        'Nurse David Wong'
      ]
    },
    {
      eventId: 'EVENT-4002',
      theatreRoom: 'Operating Room 4',
      eventType: 'Cleaning',
      eventStart: relativeDate(14, 0),
      eventEnd: relativeDate(15, 0),
      responsibleStaff: 'Cleaning Team D',
      eventDetails: 'Terminal cleaning after major procedure',
      patientId: null,
      patientName: null,
      status: 'In Progress',
      notes: 'Deep cleaning of all surfaces and equipment',
      eventCategory: 'Maintenance',
      associatedStaff: ['Andrew Lopez', 'Jessica Taylor']
    },

    // Operating Room 5 - TODAY
    {
      eventId: 'EVENT-5001',
      theatreRoom: 'Operating Room 5',
      eventType: 'Equipment Check',
      eventStart: relativeDate(9, 0),
      eventEnd: relativeDate(10, 0),
      responsibleStaff: 'Biomedical Engineering',
      eventDetails: 'Preparation and testing of equipment for upcoming mastectomy',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'All equipment functioning properly',
      eventCategory: 'Maintenance',
      associatedStaff: ['James Wilson', 'Emily Parker']
    },
    {
      eventId: 'EVENT-5002',
      theatreRoom: 'Operating Room 5',
      eventType: 'Procedure',
      eventStart: relativeDate(11, 0),
      eventEnd: relativeDate(15, 30),
      responsibleStaff: 'Dr. Jessica Adams',
      eventDetails: 'Mastectomy with Immediate Reconstruction',
      patientId: 'PT-1534',
      patientName: 'Susan Johnson',
      status: 'Completed',
      notes: 'Procedure completed successfully, patient in recovery',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Lisa Thompson', 'Dr. Michelle Rodriguez', 'Nurse Jennifer Lopez', 'Nurse David Chen']
    },

    // Cath Lab 1 - TODAY
    {
      eventId: 'EVENT-C101',
      theatreRoom: 'Cath Lab 1',
      eventType: 'Procedure',
      eventStart: relativeDate(9, 15),
      eventEnd: relativeDate(10, 30),
      responsibleStaff: 'Dr. David Lee',
      eventDetails: 'Cardiac Catheterization',
      patientId: 'PT-1523',
      patientName: 'Michael Adams',
      status: 'Completed',
      notes: 'Diagnostic procedure completed successfully',
      eventCategory: 'Cardiology Procedure',
      associatedStaff: ['Dr. Amanda Parker', 'Nurse Jennifer Lopez', 'Nurse Richard Taylor']
    },
    {
      eventId: 'EVENT-C102',
      theatreRoom: 'Cath Lab 1',
      eventType: 'Cleaning',
      eventStart: relativeDate(10, 30),
      eventEnd: relativeDate(11, 0),
      responsibleStaff: 'Cleaning Team E',
      eventDetails: 'Standard cleaning',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'Cleaning completed',
      eventCategory: 'Maintenance',
      associatedStaff: ['Karen Miller', 'David Jones']
    },
    {
      eventId: 'EVENT-C103',
      theatreRoom: 'Cath Lab 1',
      eventType: 'Procedure',
      eventStart: relativeDate(11, 30),
      eventEnd: relativeDate(13, 45),
      responsibleStaff: 'Dr. David Lee',
      eventDetails: 'Coronary Angioplasty',
      patientId: 'PT-1526',
      patientName: 'George Wilson',
      status: 'Completed',
      notes: 'Stent placed successfully',
      eventCategory: 'Cardiology Procedure',
      associatedStaff: ['Dr. Amanda Parker', 'Nurse Jennifer Lopez', 'Nurse Richard Taylor']
    },
    {
      eventId: 'EVENT-C104',
      theatreRoom: 'Cath Lab 1',
      eventType: 'Procedure',
      eventStart: relativeDate(14, 15),
      eventEnd: null,
      responsibleStaff: 'Dr. David Lee',
      eventDetails: 'Pacemaker Insertion',
      patientId: 'PT-1531',
      patientName: 'Olivia Martinez',
      status: 'In Progress',
      notes: 'Procedure proceeding as planned',
      eventCategory: 'Cardiology Procedure',
      associatedStaff: ['Dr. Amanda Parker', 'Nurse Jennifer Lopez', 'Nurse Richard Taylor']
    },

    // Cath Lab 2 - TODAY
    {
      eventId: 'EVENT-C201',
      theatreRoom: 'Cath Lab 2',
      eventType: 'Equipment Check',
      eventStart: relativeDate(8, 0),
      eventEnd: relativeDate(9, 0),
      responsibleStaff: 'Biomedical Engineering',
      eventDetails: 'Equipment calibration',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'Annual calibration completed',
      eventCategory: 'Maintenance',
      associatedStaff: ['James Wilson', 'Emily Parker']
    },
    {
      eventId: 'EVENT-C202',
      theatreRoom: 'Cath Lab 2',
      eventType: 'Procedure',
      eventStart: relativeDate(10, 0),
      eventEnd: relativeDate(12, 30),
      responsibleStaff: 'Dr. Alexandra Smith',
      eventDetails: 'Electrophysiology Study',
      patientId: 'PT-1540',
      patientName: 'Robert Johnson',
      status: 'Completed',
      notes: 'Arrhythmia identified and treated',
      eventCategory: 'Cardiology Procedure',
      associatedStaff: ['Dr. James Wilson', 'Nurse Mary Brown', 'Nurse Thomas Lee']
    },
    {
      eventId: 'EVENT-C203',
      theatreRoom: 'Cath Lab 2',
      eventType: 'Procedure',
      eventStart: relativeDate(13, 30),
      eventEnd: null,
      responsibleStaff: 'Dr. Alexandra Smith',
      eventDetails: 'Coronary Angiography',
      patientId: 'PT-1548',
      patientName: 'Sarah Davis',
      status: 'Scheduled',
      notes: 'Diagnostic procedure for suspected CAD',
      eventCategory: 'Cardiology Procedure',
      associatedStaff: ['Dr. James Wilson', 'Nurse Mary Brown', 'Nurse Thomas Lee']
    },

    // Operating Room 6 - TODAY
    {
      eventId: 'EVENT-6001',
      theatreRoom: 'Operating Room 6',
      eventType: 'Procedure',
      eventStart: relativeDate(8, 0),
      eventEnd: relativeDate(11, 0),
      responsibleStaff: 'Dr. Thomas Wright',
      eventDetails: 'Total Knee Replacement',
      patientId: 'PT-1550',
      patientName: 'Richard Brown',
      status: 'Completed',
      notes: 'Procedure completed successfully',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Lisa Walker', 'Nurse Karen White', 'Nurse David Martinez']
    },
    {
      eventId: 'EVENT-6002',
      theatreRoom: 'Operating Room 6',
      eventType: 'Cleaning',
      eventStart: relativeDate(11, 0),
      eventEnd: relativeDate(11, 45),
      responsibleStaff: 'Cleaning Team F',
      eventDetails: 'Standard cleaning',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'Cleaning completed on schedule',
      eventCategory: 'Maintenance',
      associatedStaff: ['Angela Moore', 'Carlos Rodriguez']
    },
    {
      eventId: 'EVENT-6003',
      theatreRoom: 'Operating Room 6',
      eventType: 'Procedure',
      eventStart: relativeDate(13, 0),
      eventEnd: null,
      responsibleStaff: 'Dr. Thomas Wright',
      eventDetails: 'Shoulder Arthroscopy',
      patientId: 'PT-1555',
      patientName: 'James Wilson',
      status: 'Delayed',
      notes: 'Delayed due to emergency case in OR3',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Lisa Walker', 'Nurse Karen White', 'Nurse David Martinez']
    },

    // Operating Room 7 (Robotic Surgery) - TODAY
    {
      eventId: 'EVENT-7001',
      theatreRoom: 'Operating Room 7',
      eventType: 'Equipment Check',
      eventStart: relativeDate(7, 0),
      eventEnd: relativeDate(8, 30),
      responsibleStaff: 'Robotic Surgery Team',
      eventDetails: 'Da Vinci Robot System Check',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'All systems operational',
      eventCategory: 'Maintenance',
      associatedStaff: ['Dr. Andrew Miller', 'Robotic Technician Kevin Lee']
    },
    {
      eventId: 'EVENT-7002',
      theatreRoom: 'Operating Room 7',
      eventType: 'Procedure',
      eventStart: relativeDate(9, 0),
      eventEnd: relativeDate(13, 0),
      responsibleStaff: 'Dr. Andrew Miller',
      eventDetails: 'Robotic Prostatectomy',
      patientId: 'PT-1560',
      patientName: 'Charles Davis',
      status: 'Completed',
      notes: 'Robotic procedure completed successfully',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Emma Roberts', 'Nurse Amy Zhang', 'Nurse Robert Jones', 'Robotic Technician Kevin Lee']
    },
    {
      eventId: 'EVENT-7003',
      theatreRoom: 'Operating Room 7',
      eventType: 'Cleaning',
      eventStart: relativeDate(13, 0),
      eventEnd: relativeDate(14, 0),
      responsibleStaff: 'Specialized Cleaning Team',
      eventDetails: 'Specialized cleaning of robotic equipment',
      patientId: null,
      patientName: null,
      status: 'Completed',
      notes: 'Specialized cleaning protocols followed',
      eventCategory: 'Maintenance',
      associatedStaff: ['Specialized Technician Maria Lee', 'Specialized Technician James Wong']
    },
    {
      eventId: 'EVENT-7004',
      theatreRoom: 'Operating Room 7',
      eventType: 'Procedure',
      eventStart: relativeDate(14, 30),
      eventEnd: null,
      responsibleStaff: 'Dr. Andrew Miller',
      eventDetails: 'Robotic Partial Nephrectomy',
      patientId: 'PT-1565',
      patientName: 'Elizabeth Taylor',
      status: 'In Progress',
      notes: 'Complex case, proceeding well',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Emma Roberts', 'Nurse Amy Zhang', 'Nurse Robert Jones', 'Robotic Technician Kevin Lee']
    },

    // TOMORROW'S EVENTS (Sample for a few rooms)
    {
      eventId: 'EVENT-T001',
      theatreRoom: 'Operating Room 1',
      eventType: 'Procedure',
      eventStart: tomorrowDate(8, 0),
      eventEnd: tomorrowDate(9, 30),
      responsibleStaff: 'Dr. Sarah Johnson',
      eventDetails: 'Inguinal Hernia Repair',
      patientId: 'PT-1570',
      patientName: 'Michael Brown',
      status: 'Scheduled',
      notes: 'Patient prepped and ready',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Michael Harris', 'Dr. Daniel Wright', 'Nurse Emily Clark', 'Nurse Jason Rodriguez']
    },
    {
      eventId: 'EVENT-T002',
      theatreRoom: 'Operating Room 3',
      eventType: 'Procedure',
      eventStart: tomorrowDate(10, 0),
      eventEnd: tomorrowDate(14, 0),
      responsibleStaff: 'Dr. Robert Chen',
      eventDetails: 'Colectomy',
      patientId: 'PT-1575',
      patientName: 'Anna Miller',
      status: 'Scheduled',
      notes: 'Complex case, extended time allocated',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Michael Harris', 'Dr. Amanda Parker', 'Nurse Amanda Rodriguez', 'Nurse David Wong']
    },
    {
      eventId: 'EVENT-T003',
      theatreRoom: 'Operating Room 7',
      eventType: 'Procedure',
      eventStart: tomorrowDate(9, 0),
      eventEnd: tomorrowDate(13, 0),
      responsibleStaff: 'Dr. Andrew Miller',
      eventDetails: 'Robotic Hysterectomy',
      patientId: 'PT-1580',
      patientName: 'Karen Wilson',
      status: 'Scheduled',
      notes: 'Patient scheduled for robotic procedure',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Emma Roberts', 'Nurse Amy Zhang', 'Nurse Robert Jones', 'Robotic Technician Kevin Lee']
    },

    // YESTERDAY'S EVENTS (Sample for a few rooms)
    {
      eventId: 'EVENT-Y001',
      theatreRoom: 'Operating Room 2',
      eventType: 'Procedure',
      eventStart: yesterdayDate(8, 0),
      eventEnd: yesterdayDate(10, 30),
      responsibleStaff: 'Dr. James Wilson',
      eventDetails: 'Arthroscopic ACL Repair',
      patientId: 'PT-1585',
      patientName: 'Thomas Anderson',
      status: 'Completed',
      notes: 'Procedure completed successfully',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Rachel Brown', 'Dr. Emma Taylor', 'Nurse Thomas White', 'Nurse Catherine Lee']
    },
    {
      eventId: 'EVENT-Y002',
      theatreRoom: 'Operating Room 5',
      eventType: 'Procedure',
      eventStart: yesterdayDate(9, 0),
      eventEnd: yesterdayDate(14, 0),
      responsibleStaff: 'Dr. Jessica Adams',
      eventDetails: 'Lumpectomy with Sentinel Node Biopsy',
      patientId: 'PT-1590',
      patientName: 'Margaret Davis',
      status: 'Completed',
      notes: 'Specimens sent to pathology',
      eventCategory: 'Surgery',
      associatedStaff: ['Dr. Lisa Thompson', 'Dr. Michelle Rodriguez', 'Nurse Jennifer Lopez', 'Nurse David Chen']
    },
    {
      eventId: 'EVENT-Y003',
      theatreRoom: 'Cath Lab 1',
      eventType: 'Procedure',
      eventStart: yesterdayDate(10, 0),
      eventEnd: yesterdayDate(11, 30),
      responsibleStaff: 'Dr. David Lee',
      eventDetails: 'Cardiac Catheterization with Stent Placement',
      patientId: 'PT-1595',
      patientName: 'Robert Williams',
      status: 'Completed',
      notes: 'Two stents placed, patient recovering well',
      eventCategory: 'Cardiology Procedure',
      associatedStaff: ['Dr. Amanda Parker', 'Nurse Jennifer Lopez', 'Nurse Richard Taylor']
    }
  ]
}

// Export the function result
export const theatreRoomEventsMockData = generateMockEventData()
